import { render, staticRenderFns } from "./dashboard-action.vue?vue&type=template&id=5da1afea"
import script from "./dashboard-action.vue?vue&type=script&lang=js"
export * from "./dashboard-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports